import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import {
  useDashboardContext,
} from 'Views/Dashboard/DashboardContext';
import ClientActionItems from 'Components/ClientApp/CombinedApp/Viewport/ClientActionItems';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import UpNextTaskingDesktop from './UpNextTaskingDesktop';

const ActionItemsPicker = (props) => {
  const { householdResource } = useSimpleHousehold();
  const { clientDashboardResource } = useDashboardContext();

  // If action items are available then pick if we should use the what if version or not.
  return pickFunction(clientDashboardResource, {
    [fr.relationships.tasks.name]: () => {
      return <UpNextTaskingDesktop {...props} />;
    },
    [fr.relationships.default.name]: () => {
      return pickFunction(householdResource, {
        [fr.relationships.actionItems.name]: () => {
          return (
            <ClientActionItems />
          );
        },
        [fr.relationships.default.name]: () => {
          return null;
        },
      });
    },
  });
};
export default ActionItemsPicker;
